export const ACCESS_TOKEN_KEY = 'access_token';
export const PROJECT_REGISTRATION_KEY = 'project_registration_key';
